import { Layout } from '@/bloks/Global/Layout';
import { Integration, IntegrationCategory, IntegrationListProvider } from '@/contexts/Integration';
import { getFeaturedIntegrations, getIntegrationCategories } from '@/server/appmarket';
import { DefaultProps, buildGetStaticProps } from '@/server/slug';
import Head from 'next/head';
import { GetStaticPaths } from 'next';

interface Props extends DefaultProps {
	featuredIntegrations: Integration[];
	categories: IntegrationCategory[];
}

const Page: React.FC<Props> = ({ featuredIntegrations, productCatalog, categories, ...props }) => {
	return (
		<IntegrationListProvider featuredIntegrations={featuredIntegrations} categories={categories}>
			<Head>
				<meta name="addsearch-custom-field" content="pagetype=page" />
			</Head>
			<Layout {...props} />
		</IntegrationListProvider>
	);
};

export default Page;

export const getStaticProps = buildGetStaticProps<Props>({
	initialize(params) {
		if (params.slug) {
			return { notFound: true };
		}

		const pageSlug = 'integrationer';
		const storySlug = pageSlug;

		return { build: { pageSlug, storySlug } };
	},

	async build(helper) {
		await helper.fetchProps({
			featuredIntegrations: () => getFeaturedIntegrations(),
			categories: () => getIntegrationCategories(),
		});

		await helper.fetchBreadcrumbs();
		helper.handleServerPageConfig();

		helper.result!.props.dynamicMeta = {
			canonical: '/integrationer',
		};
	},
});

export const getStaticPaths: GetStaticPaths = async () => {
	return { paths: [], fallback: 'blocking' };
};
